import './Welcome.css';
import { useNavigate } from "react-router-dom";
import { DialogContent, Dialog } from '@mui/material';
import React, { useState } from "react";
import { SuccessPopover } from '../common/commonPopovers/successPopover';

import { CHECK_STATUS, authKey } from '../common/URLs';
import ReCAPTCHA from "react-google-recaptcha";
import { Button, Container, Card, CardContent, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import BackButton from '../common/backButton';
import { PROD } from '../common/constants';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import apiClient from '../axios';

function CheckApplicationStatus() {
  const { t } = useTranslation();
  const [details, setDetails] = useState({
    urn: '',
    mobileNo: ''
  });

  const [checkDetails, setCheckDetails] = useState({});
  const [errorMessage, setErrorMessage] = useState({
    mobileNoError: "",
    urnError: ""
  })
  const navigate = useNavigate();
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => setLogModalOpen(false);
  const [showButton, setShowButton] = useState(false);
  const [showSignupLink, setShowSignupLink] = useState(false);
  const handleChange = (e) => {
    const limit = 12;
    setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
  }

  const onSubmit = (e) => {
    e.preventDefault();
    if (details.mobileNo == "") {
      setErrorMessage({ ...errorMessage, mobileNoError: "Please enter 10 digit mobile number/URN" });
    }
    else {
      setErrorMessage({ ...errorMessage, mobileNoError: "" });
      getCheckStausDetails();
    }
  };

  function getCheckStausDetails() {
    apiClient
      .post(CHECK_STATUS,
        {
          "urn": (details.mobileNo).match("[A-Z]{5}[0-9]{7}") ? details.mobileNo : null,
          "mobileNo": (details.mobileNo).match("[0-9]{10}") ? details.mobileNo : null,

        },
        {
          headers: {
            AuthKey: authKey,
          },
        })
      .then((response) => {
        setCheckDetails(response.data);
        if (response.data) {
          let status = response.data.registrationStatus;
          if ((status == "Shortlisted" || status == "Registered" || status == "Approved" || status == "Scrutiny_Initiated") && response.data?.hasSignedUp == false) {
            setShowSignupLink(true);
          }
          else {
            setShowSignupLink(false);
          }
          if (response.data?.message === "Stackholder not found") {
            toast.error("Stakeholder Not Found")
          }
          else {
            handleLogModalOpen();
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  function onChange(value) {
    setShowButton(true);
  }

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>REG09</p>}
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <BackButton navigate={navigate} navigateTo="/" />
          <Typography variant="h5" gutterBottom>
            {t('main.status')}
          </Typography>
        </Stack>
        <Card>
          <CardContent >
            <Grid container spacing={2} direction="column" style={{ display: "flex", alignItems: "center" }}>
              <TextField fullWidth required sx={{ width: '35ch', mt: 2 }}
                error={errorMessage.mobileNoError}
                helperText={errorMessage.mobileNoError}
                label={t('preReg.enterMobileNoOrUrn')}
                variant="standard"
                name="mobileNo"
                value={details.mobileNo}
                onChange={(e) => handleChange(e)}
              />
              <ReCAPTCHA style={{ marginTop: "4vh" }}
                              sitekey="6LcI4PYqAAAAADXgENhDY4jxqotf3uIeIX3SvnHf"
                onChange={onChange}
              />
              {showButton &&
                <Box display='flex' alignItems="center" justifyContent="center" mt={4}>
                  <Button variant="contained" onClick={(e) => onSubmit(e)}>{t('preReg.submit')}</Button>
                </Box>
              }
            </Grid>
          </CardContent>
        </Card>
      </Container>
      <SuccessPopover onOpen={logModalOpen} onClose={handleLogModalClose} message={checkDetails?.registrationStatus} showSignupLink={showSignupLink} urn={checkDetails.urn} />
    </>
  );
}


export default CheckApplicationStatus;
